import Bowser from 'bowser';

export function isSupportedBrowserVersion(userAgent, minAcceptedVersions) {
  const browser = Bowser.getParser(userAgent);

  for (const { browserName, version } of minAcceptedVersions) {
    if (browser.satisfies({ [browserName]: `<${version}` })) {
      return false;
    }
  }

  return true;
}